<template>
  <div>
    <el-pagination
        background
        v-bind="$attrs"
        v-on="$listeners"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {}
</script>


<style scoped lang="scss">
/deep/ .el-pagination {
  display: inline-block;

  .btn-prev, .btn-next{
    width: 56px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #999999;
    font-size: 14px;
    color: #999999;
    background: #fff;
  }

  .el-pager {
    .number,.more  {
      width: 32px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #999999;
      background: #fff;
      font-size: 14px;
      color: #999999;
      margin: 0 4px;

      &.active {
        background-color: $color-main2 !important;
        color: #fff !important;
        border: 1px solid transparent;
      }
    }

  }
}
</style>
